import styled, {css} from 'styled-components';
import {StyledProps} from './typings';
import {sizePx} from '@/theme/helpers/size';

const StyledImgFigure = styled.figure<StyledProps>`
  ${(props) => css`
    ${!props.$preview &&
    css`
      background-color: #${props.$mainColor};
    `}
    position: relative;
    margin: 0;
    overflow: hidden;
    ${props.$responsive
      ? css`
          aspect-ratio: ${props.$width} / ${props.$height};
        `
      : css`
          width: ${props.$width}px;
          height: ${props.$height}px;
        `}

    ${props.$preview &&
    css`
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-image: url('${props.$preview}');
        background-repeat: no-repeat;
        background-size: cover;
        filter: blur(${sizePx(5)});
        transform: scale(1.1);
      }
    `}    

    & img {
      transition: opacity 0.2s ease-out;
      position: absolute;
      opacity: ${props.$imageLoaded ? 1 : 0};
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `}

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export default StyledImgFigure;
